import React from 'react';
import { useLocalStorage } from '../../../../hooks/useLocalStorage';
import { useTranslation } from 'react-i18next';
import './NameEditForm.css';

interface NameEditFormProps {
  onSave: (playerName: string) => void;
}

const NameEditForm: React.FC<NameEditFormProps> = ({ onSave }) => {
  const [playerName, setPlayerName] = useLocalStorage('playerName', '');
  const { t } = useTranslation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (playerName.trim()) {
      onSave(playerName.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form-section">
      <div className="flex-column gap-small">
        <label htmlFor="playerName" className="text-center">Enter your name to join:</label>
        <input
          id="playerName"
          type="text"
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          placeholder="Your name"
          className="name-input"
          autoFocus
          required
        />
      </div>

      <button 
        type="submit"
        disabled={!playerName.trim()}
        className="btn btn-primary btn-large"
      >
        {t('game.joinGame')}
      </button>
    </form>
  );
};

export default NameEditForm;